export class ObjectTypesHelper {
  private static readonly AbwLeitung = 'AbwLeitung';
  private static readonly AbwKnoten = 'AbwKnoten';
  private static readonly VsLeitung = 'VsLeitung';
  private static readonly VsKnoten = 'VsKnoten';
  private static readonly WaLeitung = 'WaLeitung';
  private static readonly WaKnoten = 'WaKnoten';
  private static readonly GaLeitung = 'GaLeitung';
  private static readonly GaKnoten = 'GaKnoten';
  private static readonly EnTrassenabschnitt = 'EnTrassenabschnitt';
  private static readonly EnKnoten = 'EnKnoten';
  private static readonly PiSeriesEventRange = 'PiSeriesEventRange';
  private static readonly PiNode = 'PiNode';

  constructor() {}

  public static getEdgeObjectType(objectTypeNames: string[]): string {
    if (objectTypeNames) {
      for (let ot of objectTypeNames) {
        if (ot.startsWith('Abw')) {
          return this.AbwLeitung;
        } else if (ot.startsWith('Vs')) {
          return this.VsLeitung;
        } else if (ot.startsWith('Wa')) {
          return this.WaLeitung;
        } else if (ot.startsWith('Ga')) {
          return this.GaLeitung;
        } else if (ot.startsWith('En')) {
          return this.EnTrassenabschnitt;
        } else if (ot.startsWith('Pi')) {
          return this.PiSeriesEventRange;
        }
      }
    }
    return null;
  }

  public static getMainNodeObjectType(edgeObjectType: string): string {
    if (edgeObjectType) {
      if (edgeObjectType.startsWith('Abw')) {
        return this.AbwKnoten;
      } else if (edgeObjectType.startsWith('Vs')) {
        return this.VsKnoten;
      } else if (edgeObjectType.startsWith('Wa')) {
        return this.WaKnoten;
      } else if (edgeObjectType.startsWith('Ga')) {
        return this.GaKnoten;
      } else if (edgeObjectType.startsWith('En')) {
        return this.EnKnoten;
      } else if (edgeObjectType.startsWith('Pi')) {
        return this.PiNode;
      }
    }
    return null;
  }

  public static getStartNodeOpathByEdgeType(edgeMainType: string): string {
    let ret = '';
    if (edgeMainType === this.AbwLeitung || edgeMainType === this.VsLeitung) ret = 'KnotenAnf';
    else if (edgeMainType === this.EnTrassenabschnitt) ret = 'KnotenStart';
    else if (edgeMainType === this.PiSeriesEventRange) ret = 'BeginNode';

    return ret;
  }

  public static getEndNodeOpathByEdgeType(edgeMainType: string): string {
    let ret = '';
    if (edgeMainType === this.AbwLeitung || edgeMainType === this.VsLeitung) ret = 'KnotenEnd';
    else if (edgeMainType === this.EnTrassenabschnitt) ret = 'KnotenEnd';
    else if (edgeMainType === this.PiSeriesEventRange) ret = 'EndNode';

    return ret;
  }

  public static getSubNodeOpathByEdgeType(edgeMainType: string): string {
    let ret = '';
    if (edgeMainType === this.AbwLeitung) ret = 'AbwKnotenListChildren';
    else if (edgeMainType === this.VsLeitung) ret = 'VsKnotenListChildren';

    return ret;
  }

  public static isNodeObjectType(mainTypeName: string): boolean {
    return (
      mainTypeName === this.AbwKnoten ||
      mainTypeName === this.VsKnoten ||
      mainTypeName === this.WaKnoten ||
      mainTypeName === this.GaKnoten ||
      mainTypeName === this.EnKnoten ||
      mainTypeName === this.PiNode
    );
  }

  public static getMainEdgeObjectTypes(): string[] {
    return [this.AbwLeitung, this.VsLeitung, this.EnTrassenabschnitt, this.PiSeriesEventRange];
  }
}
